// @flow

import { createAction } from 'redux-actions';
import { push } from 'react-router-redux';
import get from 'lodash/get';
import type { ApiType, DispatchType, GetStateType } from 'types/redux';

import userAuth from 'utils/user-auth';

export const localTutorLogout = createAction<'LOCAL_TUTOR_LOGOUT', any>('LOCAL_TUTOR_LOGOUT');

export const postTutorResetPasswordEmailRequest = createAction<
  'POST_TUTOR_RESET_PASSWORD_EMAIL_REQUEST',
  any,
>('POST_TUTOR_RESET_PASSWORD_EMAIL_REQUEST');
export const postTutorResetPasswordEmailSuccess = createAction<
  'POST_TUTOR_RESET_PASSWORD_EMAIL_SUCCESS',
  any,
>('POST_TUTOR_RESET_PASSWORD_EMAIL_SUCCESS');
export const postTutorResetPasswordEmailFailure = createAction<
  'POST_TUTOR_RESET_PASSWORD_EMAIL_FAILURE',
  any,
>('POST_TUTOR_RESET_PASSWORD_EMAIL_FAILURE');

export const postTutorPasswordRequest = createAction<'POST_TUTOR_PASSWORD_REQUEST', any>(
  'POST_TUTOR_PASSWORD_REQUEST',
);
export const postTutorPasswordSuccess = createAction<'POST_TUTOR_PASSWORD_SUCCESS', any>(
  'POST_TUTOR_PASSWORD_SUCCESS',
);
export const postTutorPasswordFailure = createAction<'POST_TUTOR_PASSWORD_FAILURE', any>(
  'POST_TUTOR_PASSWORD_FAILURE',
);

export const postTutorSignInRequest = createAction<'POST_TUTOR_SIGN_IN_REQUEST', any>(
  'POST_TUTOR_SIGN_IN_REQUEST',
);
export const postTutorSignInSuccess = createAction<'POST_TUTOR_SIGN_IN_SUCCESS', any>(
  'POST_TUTOR_SIGN_IN_SUCCESS',
);
export const postTutorSignInFailure = createAction<'POST_TUTOR_SIGN_IN_FAILURE', any>(
  'POST_TUTOR_SIGN_IN_FAILURE',
);

export const tutorLogout = () => (dispatch: DispatchType) => {
  userAuth.clear();
  dispatch(localTutorLogout());
  dispatch(push('/'));
};

export const subscribeToCalendar = () => async (
  dispatch: DispatchType,
  getState: GetStateType,
  api: ApiType,
) => {
  const response = await api.subscribeToCalendar();
  api.checkStatus(response);
  userAuth.mergeAttributes({ isSubscribedToOwnGoogleCalendar: true });
};

export const unsubscribeFromCalendar = () => async (
  dispatch: DispatchType,
  getState: GetStateType,
  api: ApiType,
) => {
  const response = await api.unsubscribeFromCalendar();
  api.checkStatus(response);
  userAuth.mergeAttributes({ isSubscribedToOwnGoogleCalendar: false });
};

export const postTutorResetPasswordEmail = (data: any) => async (
  dispatch: DispatchType,
  getState: GetStateType,
  api: ApiType,
) => {
  dispatch(postTutorResetPasswordEmailRequest());

  try {
    const response = await api.postTutorResetPasswordEmail(data);
    api.checkStatus(response);
    dispatch(postTutorResetPasswordEmailSuccess());
  } catch (error) {
    dispatch(postTutorResetPasswordEmailFailure(error));
  }
};

export const postTutorPassword = (data: any) => async (
  dispatch: DispatchType,
  getState: GetStateType,
  api: ApiType,
) => {
  dispatch(postTutorPasswordRequest());

  try {
    const response = await api.postTutorPassword(data);
    api.checkStatus(response);
    dispatch(postTutorPasswordSuccess());
    dispatch(push('/sign-in'));
  } catch (error) {
    dispatch(postTutorPasswordFailure(error));
  }
};

const setUserAuth = response => {
  const { tutors, businesses = {} } = response;
  const [
    {
      id,
      attributes: { firstName, lastName, email, isSubscribedToOwnGoogleCalendar },
    },
  ] = (Object.values(tutors): any);
  const businessId = Object.keys(businesses)[0];
  const business = businesses[businessId];
  const logoUrl = get(business, 'attributes.logoUrl');
  const businessName = get(business, 'attributes.name');

  const tutorAuthJson = {
    id,
    type: 'tutors',
    attributes: {
      firstName,
      lastName,
      email,
      isSubscribedToOwnGoogleCalendar,
    },
    business: {
      id: businessId,
      name: businessName,
      logoUrl,
    },
  };

  userAuth.set(JSON.stringify(tutorAuthJson));
};

export const postTutorSignIn = (attributes: any) => async (
  dispatch: DispatchType,
  getState: GetStateType,
  api: ApiType,
) => {
  dispatch(postTutorSignInRequest());
  try {
    const data = { data: { attributes } };
    const response = await api.postTutorSignIn(data);
    api.checkStatus(response);
    setUserAuth(response);
    dispatch(postTutorSignInSuccess(response.tutors));
    dispatch(push('/dashboard'));
  } catch (error) {
    dispatch(postTutorSignInFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/actions/tutor/index.js